__turbopack_context__.v({
  "close": "bottomSheet-module-scss-module__iYMIva__close",
  "content": "bottomSheet-module-scss-module__iYMIva__content",
  "header": "bottomSheet-module-scss-module__iYMIva__header",
  "panel": "bottomSheet-module-scss-module__iYMIva__panel",
  "sheet": "bottomSheet-module-scss-module__iYMIva__sheet",
  "slideUp": "bottomSheet-module-scss-module__iYMIva__slideUp",
  "title": "bottomSheet-module-scss-module__iYMIva__title",
});
